export default {
  translation: {
    // Navigation
    'nav.about': 'About the ABC Method',
    'nav.privacy': 'Privacy',
    'nav.imprint': 'Imprint',

    // Homepage
    'home.title': 'Creative Brainstorming with the ABC Method',
    'home.subtitle': 'Let the alphabet inspire you and develop new ideas',
    'home.topic.label': 'What topic would you like to brainstorm?',
    'home.topic.placeholder': 'e.g. Ideas for my startup',
    'home.nickname.label': 'Your nickname',
    'home.nickname.placeholder': 'How should other participants see you?',
    'home.start.button': 'Start your brainstorming',

    // Homepage new sections
    'home.explanation.title': 'The ABC Method Explained',
    'home.explanation.intro': 'The ABC Method uses the power of the alphabet to unlock your creativity and develop new ideas. Here\'s how it works:',
    'home.explanation.step1': 'Choose your topic that you want to brainstorm ideas for',
    'home.explanation.step2': 'Use the letters of the alphabet as triggers for your associations',
    'home.explanation.step3': 'Discover new connections between your ideas',
    'home.explanation.learn_more': 'Learn more about the method',
    
    'home.form.title': 'Start Your Brainstorming Session',
    
    'home.features.title': 'Why ABCbrain?',
    'home.features.method.title': 'Proven Method',
    'home.features.method.description': 'The ABC Method by Vera F. Birkenbihl is a proven effective technique for overcoming mental blocks and finding new perspectives.',
    'home.features.ai.title': 'AI Analysis',
    'home.features.ai.description': 'Have your ideas analyzed by artificial intelligence and receive surprising insights and connections.',
    'home.features.collaborate.title': 'Collaboration',
    'home.features.collaborate.description': 'Brainstorm with up to 5 people simultaneously in real-time and harness your collective creative energy.',

    // Session
    'session.participants': 'Participants',
    'session.participants.count': 'Brainstorming session with',
    'session.participants.limit': 'of',
    'session.session_of': 'Brainstorming session by',
    'session.progress': 'Progress',
    'session.letters': 'Letters',
    'session.words': 'Words',
    'session.invite': 'Copy link and invite',
    'session.finish': 'End brainstorming',
    'session.resume': 'Resume brainstorming',
    'session.finished': 'Brainstorming has ended',
    'session.finished_message': 'This brainstorming session is complete. You can review the results or start a new session.',
    'session.start_new_session': 'Start new session',
    'session.readonly': 'Read-only mode',
    'session.invalid': 'Session not found',
    'session.expired': 'This session has expired',
    'session.join.title': 'Join session',
    'session.join.button': 'Join session',

    // Session Timer
    'session.timer.expired': 'Expired',
    'session.timer.days': '{{count}} day(s) left',
    'session.timer.hours': '{{count}} hour(s) left',
    'session.timer.minutes': '{{count}} minute(s) left',
    'session.timer.info.aria': 'More information about expiration time',
    'session.timer.info.tooltip': 'This session automatically expires after 30 days',

    'session.tip.difficult_letters': 'Tip: Try difficult letters like Q, X, or Y.',
    'session.start_own': 'Start your own session',
    'session.start_own.description': 'Start your own brainstorming session and collect creative ideas with the ABC method.',
    'session.start_new': 'Start new session',
    'session.invite.copied': 'Link copied!',

    // Analysis
    'analysis.title': 'AI Analysis of your Ideas',
    'analysis.request': 'Analyze ideas now',
    'analysis.request_new': 'Request new analysis',
    'analysis.loading': 'Analyzing your ideas...',
    'analysis.error': 'There was an error during analysis',
    'analysis.retry': 'Close and try again',
    'analysis.available': 'An AI analysis of your ideas is available.',
    'analysis.description': 'Get a detailed AI analysis of your brainstorming session with key insights.',
    'analysis.show': 'Show analysis',
    'analysis.entries_needed': '{{count}} more entries until analysis',
    'analysis.price': '(1 CHF)',
    'analysis.price_info': '1 CHF (one-time payment)',
    'analysis.beta_free': 'Free during beta phase',

    // ABC Method Page
    'abc.title': 'The ABC Method',
    'abc.subtitle': 'Creative Brainstorming by Vera F. Birkenbihl - simply explained and immediately applicable',
    'abc.intro': 'The ABC method on ABCbrain.xyz transforms your brainstorming sessions into a creative adventure. Developed by Vera F. Birkenbihl, this method harnesses the power of associative cognition - our brain\'s natural ability to playfully connect information - making it your personal toolkit for fresh, unconventional ideas.',
    'abc.start.button': 'Start for free now',
    
    'abc.how_it_works.title': 'How the ABC Method Works',
    'abc.how_it_works.step1.title': 'Step 1 - Choose your topic',
    'abc.how_it_works.step1.description': 'Start with a specific topic, question, or challenge for which you\'re seeking new perspectives. Example: "New business ideas".',
    'abc.how_it_works.step2.title': 'Step 2 - Associate spontaneously',
    'abc.how_it_works.step2.description': 'Write down words that come to mind spontaneously and without thinking for each letter of the alphabet. The automatically scrolling letters on ABCbrain.xyz provide visual prompts, but you\'re completely free to choose your own letters and terms at any time.',
    'abc.how_it_works.step2.example.title': 'Example:',
    'abc.how_it_works.step2.example.a': 'Apple vending machine',
    'abc.how_it_works.step2.example.b': 'Boutique station café',
    'abc.how_it_works.step2.example.c': 'Coworking space',
    'abc.how_it_works.step2.example.d': 'Drone delivery service',
    'abc.how_it_works.step3.title': 'Step 3 - Discover new connections',
    'abc.how_it_works.step3.description': 'By collecting seemingly unrelated ideas, surprising and innovative connections emerge. Perhaps the combination of "Apple vending machine" and "Boutique station café" creates a mobile, healthy snack option for commuters.',
    
    'abc.why_effective.title': 'Why is the method so effective?',
    'abc.why_effective.description': 'Our brain loves to associate freely - creating new connections between concepts we normally perceive separately. This phenomenon, known as associative cognition, is actively used to overcome mental blocks and promote creative flow.',
    
    'abc.ai_support.title': 'AI Support for Even More Ideas',
    'abc.ai_support.description': 'After creating your ABC list, the integrated AI automatically analyzes your results and creates a clear clustering. This helps you recognize surprising patterns, new connections, and provides further inspiring impulses.',
    
    'abc.ready.title': 'Ready to get creative?',
    'abc.ready.description': 'Whether for professional, personal, or your next passion project: The ABC method brings fresh air to your thinking processes and inspires you to extraordinary ideas. Test it now for free and discover where your creativity can lead you!',
    
    'abc.cta.title': 'Start your creative adventure!',

    // Common
    'common.loading': 'Loading...',
    'common.error': 'An error occurred',
    'common.retry': 'Try again',
    'common.close': 'Close',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.home': 'Back to homepage',

    // Error pages
    'error.404.title': '404 - Page not found',
    'error.404.message': 'The link might have expired or the session has ended.',

    // Connection Error
    'error.connection.title': 'Connection Error',
    'error.connection.message': 'Could not connect to the server. Please check your internet connection and try again.',
    'error.connection.connecting': 'Connecting...',
    'error.connection.retry': 'Try again',

    // Privacy Page
    'privacy.title': 'Privacy Policy',
    'privacy.subtitle': 'Because privacy matters – and because I have to.',
    'privacy.intro': 'Hi! I\'m Patrick, your host at ABCbrain.xyz. I love creative ideas – but not unnecessary data. Still, I need to clarify a few things here.',
    
    'privacy.data.title': 'What data is collected?',
    'privacy.data.subtitle': 'In short: As little as possible, but some things are necessary.',
    'privacy.data.visit.title': 'When you visit the website:',
    'privacy.data.visit.text': 'Netlify collects some technical data (IP address, browser type, etc.) to keep everything running smoothly.',
    'privacy.data.brainstorm.title': 'When you brainstorm:',
    'privacy.data.brainstorm.text': 'Your brilliant word creations are securely stored in a Supabase database so you can access them later.',
    'privacy.data.payment.title': 'When you pay:',
    'privacy.data.payment.text': 'That\'s handled by Stripe – I don\'t even see if you pay by card, apple, banana, or crypto. Stripe handles that with their own security measures.',
    'privacy.data.message.title': 'When you send me a message:',
    'privacy.data.message.text': 'It lands in my inbox, but I promise not to share it with aliens. 👽',
    
    'privacy.ai.title': 'What does OpenAI do with your ideas?',
    'privacy.ai.text': 'The AI summary runs through OpenAI, but don\'t worry – your inputs aren\'t stored (at least not by me). If OpenAI takes notes, that\'s beyond my control.',
    
    'privacy.not.title': 'What I DON\'T do',
    'privacy.not.sell': 'I don\'t sell your data.',
    'privacy.not.track': 'I don\'t track you across the internet.',
    'privacy.not.spam': 'I don\'t send annoying newsletters with "Only 24h left" offers.',
    
    'privacy.cookies.title': 'Cookies & Tracking',
    'privacy.cookies.text1': 'I love cookies 🍪, but ABCbrain.xyz only uses necessary technical cookies.',
    'privacy.cookies.text2': 'No Google Analytics, no creepy retargeting – I don\'t want to track you.',
    
    'privacy.rights.title': 'Your Rights',
    'privacy.rights.text': 'If you want your data deleted, just let me know. I can\'t pull anything from OpenAI or Stripe, but I\'ll gladly delete your Supabase data with one click.',
    
    'privacy.legal.title': 'Legal Stuff & Final Words',
    'privacy.legal.text': 'If you\'re really serious about privacy, I recommend: Just don\'t enter any secret world formulas or superhero plans on the site.',
    
    'privacy.contact.text': 'Questions? Privacy concerns? Just reach out!',

    // Imprint Page
    'imprint.title': 'Imprint',
    'imprint.subtitle': 'Responsible for this creative madness',
    'imprint.contact.title': 'Contact Information',
    'imprint.contact.name': 'Patrick Hablützel',
    'imprint.contact.location': 'Secret Think Tank, somewhere in Switzerland 🏔️',
    'imprint.contact.phone': 'Not yet equipped with AI support',
    'imprint.about.title': 'About ABCbrain.xyz',
    'imprint.about.intro': 'Your smart companion for ideation! 🚀',
    'imprint.about.description': 'With automatically scrolling letters, we take your brainstorming to a new level. Perfect for flashes of inspiration, spontaneous genius, and creative escalations!',
    'imprint.ai.title': 'AI Power from OpenAI',
    'imprint.ai.points': {
      'generation': 'The smart summary of your ideas is generated by artificial intelligence from OpenAI.',
      'disclaimer': 'If the AI sometimes talks nonsense – well, machines have creative days too. 🤖💡',
      'liability': 'No liability for sudden inspirations, genius business ideas, or spontaneous enlightenment.'
    },
    'imprint.privacy.title': 'Privacy? Of course!',
    'imprint.privacy.points': {
      'ownership': 'Your ideas belong to you. I don\'t store anything that doesn\'t need to be stored (unless the AI keeps a secret diary).',
      'openai': 'Communication with OpenAI runs through their API – I have no access to their internal thought processes.'
    },
    'imprint.legal.title': 'Important Legal Stuff',
    'imprint.legal.points': {
      'hobby': 'ABCbrain.xyz is a hobby project',
      'success': 'If ABCbrain helps you become the next Steve Jobs – remember me when building your empire!'
    },

    // Export
    'export.title': 'ABC Brainstorming',
    'export.exported_at': 'Exported on',
    'export.entries': 'Entries',
    'export.letter': 'Letter',
    'export.ai_analysis': 'AI Analysis',
    'export.success': 'Exported!',
    'export.download': 'Download list',

    // Letter Grid
    'letter_grid.input.placeholder': 'Enter a word...',
    'letter_grid.letter': 'Letter',
    'letter_grid.entry.by': 'by',
    'letter_grid.entry.you': 'you',
    'letter_grid.participant.former': 'former participant',
    'letter_grid.error.duplicate': 'This word has already been entered',
    'letter_grid.error.save_failed': 'Entry could not be saved. Please try again.',

    // Scrolling Alphabet
    'scrolling_alphabet.pause': 'Pause',
    'scrolling_alphabet.resume': 'Resume',

    // Share Button
    'share.result.copy': 'Copy result link',
    'share.result.copied': 'Result link copied!',
    'share.result.aria': 'Copy result link',
    'share.resume.copy': 'Copy resume link',
    'share.resume.copied': 'Resume link copied!',
    'share.resume.aria': 'Copy resume link',
    'share.error.create': 'Error creating link',
    'share.error.copy': 'Could not copy link',

    // Summary Modal
    'summary.title': 'AI Analysis of your Ideas',
    'summary.loading': 'Analyzing your ideas...',
    'summary.error.title': 'There was an error during analysis',
    'summary.error.retry': 'Close and try again',
    'summary.payment.description': 'To receive the AI analysis of your ideas, proceed with the payment. The amount of 1 CHF will be securely processed through Stripe.',
    'summary.payment.button': 'Proceed to secure payment',
    'summary.disclaimer': 'This analysis was created by AI and serves as inspiration. The final evaluation and selection of ideas is up to you.',
    'summary.refresh': 'New analysis'
  }
};